export const PRIORITY_META = {
  urgent: {
    labelKey: 'TASKS.PRIORITY.URGENT',
    bar: 'bg-n-ruby-9',
    dot: 'text-n-ruby-9',
    bg: 'bg-n-ruby-2',
    text: 'text-n-ruby-11',
  },
  high: {
    labelKey: 'TASKS.PRIORITY.HIGH',
    bar: 'bg-n-amber-9',
    dot: 'text-n-amber-9',
    bg: 'bg-n-amber-2',
    text: 'text-n-amber-11',
  },
  normal: {
    labelKey: 'TASKS.PRIORITY.NORMAL',
    bar: 'bg-n-blue-9',
    dot: 'text-n-blue-9',
    bg: 'bg-n-blue-2',
    text: 'text-n-blue-11',
  },
  no_priority: {
    labelKey: 'TASKS.PRIORITY.NONE',
    barStyle: { backgroundColor: '#777B84' },
    dotStyle: { color: '#777B84' },
    bgColor: 'rgba(119,123,132,0.12)',
    textColor: '#777B84',
  },
};

export const PRIORITY_ORDER = ['urgent', 'high', 'normal', 'no_priority'];

export function priorityMeta(priority) {
  return PRIORITY_META[priority] ?? PRIORITY_META.no_priority;
}

export function priorityRank(priority) {
  const idx = PRIORITY_ORDER.indexOf(priority);
  return idx === -1 ? PRIORITY_ORDER.length : idx;
}
